import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AdminService } from './admin.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  constructor(
    private admin: AdminService,
    private router: Router
  ) { }

  canActivate(): Observable<boolean | UrlTree> {
    return this.admin.checkAdmin().pipe(
      map(isAdmin => isAdmin ? true : this.router.parseUrl('/no-access'))
    );
  }
}
